import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faStop,
  faHourglass,
  faPause,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import crudApi from "@serie3/common/api/crudApi";
import TimetrackingConfig from "@serie3/freelancesplaceapi/Config/Timetracking/TimetrackingConfig";
import { btn, btnHoverStyle } from "./buttonStyles";

const TimetrackingButton = ({ task, startUrl, tasks, setTasks }) => {
  const [status, setStatus] = useState("");
  const [localTask, setLocalTask] = useState();

  useEffect(() => {
    if (typeof task === "object" && task !== null) {
      const currentDate = new Date();
      const inputDate = new Date(task.date);
      if (inputDate.toDateString() === currentDate.toDateString()) {
        if (typeof task.pause_start !== "undefined") {
          setStatus("paused");
        } else {
          setStatus("running");
        }
        setLocalTask(task);
      }
    }
  }, [task]);

  const start = async () => {
    if (typeof startUrl === "undefined") {
      startUrl = TimetrackingConfig.endpoints.start;
    }
    const response = await crudApi.justGet(startUrl);
    if (response.status === 200) {
      const newTask = response.data;
      tasks.push(newTask);
      setTasks([...tasks]);
      setStatus("running");
      setLocalTask(newTask);
    }
  };

  const pause = async () => {
    const response = await crudApi.justGet(
      TimetrackingConfig.endpoints.pause + localTask.id
    );
    if (response.status === 200) {
      setStatus("paused");
    }
  };

  const resume = async () => {
    const response = await crudApi.justGet(
      TimetrackingConfig.endpoints.resume + localTask.id
    );
    if (response.status === 200) {
      setStatus("running");
    }
  };

  const stop = async () => {
    const response = await crudApi.justGet(
      TimetrackingConfig.endpoints.stop + localTask.id
    );
    if (response.status === 200) {
      setLocalTask();
    }
  };

  const circleBtn = (color, bg, onClick, children, spin) => (
    <button
      className="btn-modern"
      onClick={onClick}
      style={{
        ...btn.base,
        background: bg,
        color,
        border: "none",
        width: "32px",
        height: "32px",
        padding: 0,
        borderRadius: "50%",
        fontSize: "0.82rem",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      }}
    >
      <FontAwesomeIcon icon={children} className={spin ? "fa-spin" : ""} />
    </button>
  );

  const RunningButtons = () => {
    switch (status) {
      case "running":
        return (
          <div style={{ display: "inline-flex", gap: "6px" }}>
            {circleBtn("#fff", "#2e7d32", null, faHourglass, true)}
            {circleBtn("#fff", "#f57c00", pause, faPause, false)}
            {circleBtn("#fff", "#c62828", stop, faStop, false)}
          </div>
        );
      case "paused":
        return (
          <div style={{ display: "inline-flex", gap: "6px" }}>
            {circleBtn("#fff", "#2e7d32", resume, faPlay, false)}
            {circleBtn("#fff", "#c62828", stop, faStop, false)}
          </div>
        );
      default:
        return null;
    }
  };

  const StartButton = () =>
    circleBtn("#fff", "#2e7d32", localTask ? resume : start, faPlay, false);

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "8px" }}>
      <style>{btnHoverStyle}</style>
      {typeof localTask !== "undefined" ? <RunningButtons /> : <StartButton />}
    </div>
  );
};

export default TimetrackingButton;
